module.exports = __webpack_public_path__ + "static/img/poster_bg.1a429ad6.png";